"use client"
import Intro from '@/ui/Intro'
import React from 'react'
import layer2 from "@/assets/whoweare/secondlayer.svg"
import logo1 from "@/assets/logo/UGC.png"
import logo2 from "@/assets/logo/NSDC.png"
import logo3 from "@/assets/logo/NCVET.png"
import logo4 from "@/assets/logo/Govt-of-Sikkim.png"
import logo5 from "@/assets/logo/DGT.png"
import logo6 from "@/assets/logo/AIU.png"
import logo7 from "@/assets/logo/ISO2018.png"
import logo8 from "@/assets/logo/NAPS.png"
import logo9 from "@/assets/logo/NATS.png"
import logo10 from "@/assets/logo/PCI.png"
import logo11 from "@/assets/logo/SNC.png"
import logo12 from "@/assets/logo/paramedicalcouncil.png"
import Image from 'next/image'

const Recognition = () => {
    const items = [
        { logo: logo1 },
        { logo: logo2 },
        { logo: logo3 },
        { logo: logo4 },
        { logo: logo5 },
        { logo: logo6 },
        { logo: logo7 },
        { logo: logo8 },
        { logo: logo9 },
        { logo: logo10 },
        { logo: logo11 },
        { logo: logo12 },
    ]

    return (
        <div className=''>
            <div className='bg-white w-full pb-14  relative'>
                <div className='absolute inset-0 top-0 left-0 w-full'>
                    <Image src={layer2} alt="layer2" className="w-full h-full object-cover" />
                </div>
                <div className='page-container overflow-hidden  '>
                    <Intro className='' title="Recognitions & Accreditations" description="Recognised and Approved by Statutory Authorities" />
                    <div className='grid xl:grid-cols-6 md:grid-cols-3 grid-cols-2 relative overflow-hidden gap-10   '>
                        {
                            items.map((item, i) => (
                                <div key={i} className='bg-white grid place-items-center  rounded-full w-[180px] h-[180px]'>
                                    <Image src={item.logo} width={100} height={100} alt="logos" className="  object-cover" />
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Recognition